import { useRef } from 'react';
export const useFocus = () => {
    const htmlElRef = useRef(null);
    const setFocus = (select = false) => {
        htmlElRef.current && htmlElRef.current.focus();
        select && htmlElRef.current && htmlElRef.current.select();
    };

    return [htmlElRef, setFocus];
};
